import React, { useEffect, useState } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaAngleRight,
  FaBabyCarriage,
  FaHome,
  FaLocationArrow,
  FaLuggageCart,
  FaMap,
  FaMapPin,
  FaRupeeSign,
  FaSearch,
  FaShoppingBag,
  FaStar,
} from "react-icons/fa";
import ScheduleInterviewPopup from "../schedule/scheduleInterviewPopup";

function ViewResumes({ attachments, candidate }) {
  const [attachmentData, setAttachmentData] = useState([]);
  const [selectedResume, setSelectedResume] = useState(null);
  const [docLink, setDocLink] = useState("");
  const [isPdf, setIsPdf] = useState(false);
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [candidateId, setCandidateId] = useState("");

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const closePopup = () => {
    setScheduleInterview(false);
  };

  const candidateInterview = (id) => {
    console.log("canID", id);
    setCandidateId(id);
    setScheduleInterview(true);
    // setOpening(candidate);
  };

  // useEffect(()=>{
  //   if (attachments.length > 1) {
  //     setAttachmentData(attachments);
  //     setSelectedResume(attachments[0]);
  //     setDocLink(attachments[0].file_link);
  //     setIsPdf(attachments[0].file_link.toLowerCase().endsWith(".pdf"));
  //   }else if (attachments.length==1) {
  //     setAttachmentData(attachments);
  //     setSelectedResume(attachments[0]);
  //     setDocLink(attachments[0].file_link);
  //     setIsPdf(attachments[0].file_link.toLowerCase().endsWith(".pdf"));
  //   }
  // },[attachments])
  useEffect(() => {
    if (attachments.length == 1) {
      setSelectedResume(attachments[0]);
      setDocLink(attachments[0].file_link);
      setIsPdf(attachments[0].file_link.toLowerCase().endsWith(".pdf"));
    }
  }, [attachments]);

  const handleResumeSelect = (attachmentId) => {
    if (attachmentId) {
      const selectedResumeObject = attachments.find(
        (attachment) => attachment.id == attachmentId
      );
      setSelectedResume(selectedResumeObject);
      setDocLink(selectedResumeObject.file_link);
      setIsPdf(selectedResumeObject.file_link.toLowerCase().endsWith(".pdf"));
    } else {
      setSelectedResume(null);
    }
  };

  return (
        <div className="crnRes view-resume-box">
          <div className="text-end mb-2">
            <button
              className=" btn-btn btn btn-btn2 mb-2"
              onClick={() => candidateInterview(candidate.id)}
            >
              Schedule Interview
            </button>
            {attachments.length > 1 && (
              <select
                className="col-md-3 form-control mb-3"
                value={selectedResume ? selectedResume.id : ""}
                onChange={(e) => handleResumeSelect(e.target.value)}
              >
                <option value="">Select a Resume</option>
                {attachments.map((attachment, index) => (
                  <option key={attachment.id} value={attachment.id}>
                    Resume-
                    {formatDateToCustomFormat(attachment.created_on)}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="" style={{ height: "1000px" }}>
            <>
              <iframe
                title="resume"
                src={
                  isPdf
                    ? `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                        docLink
                      )}`
                    : `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                        docLink
                      )}`
                }
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ height: "1000px" }}
              ></iframe>
            </>
          </div>
      {scheduleInterview && (
        <ScheduleInterviewPopup
          onClose={closePopup}
          candidateId={candidateId}
          // opening={opening}
        />
      )}
    </div>
  );
}

export default ViewResumes;
